import React from 'react'

class InstrumentRepairDetail extends React.Component {
	state = {
		id: this.props.id || 0,
		readOnly: this.props.readOnly || false,
	}

	componentDidMount = () => {
		this.doGetInstrumentRepair(this.state.id)
	}

	doGetInstrumentRepair = (id) => {
		Tyan.doPostEvent('GetInstrumentRepair', {
			data: { id },
			onEnd: ({ errorMessage, optionsParas, initValues基本信息, }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, optionsParas, initValues基本信息, changedValues基本信息: {}, })
				}
			}
		})
	}

	handlerSave = () => {
		const { id } = this.state
		Tyan.doPostEvent('SaveInstrumentRepair', {
			data: Tyan.utility.getChangedFieldsets(this, '基本信息', false),
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					this.doGetInstrumentRepair(id)
				}
			}
		})
	}

	handlerDelete = () => {
		const { onClose } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () => {
			Tyan.doPostEvent('DelInstrumentRepair', {
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					} else {
						Ext.toast('删除成功')
						onClose && onClose()
					}
				}
			})
		})
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}


	canSave = () => {
		return this.bChanged() && !Tyan.checkForm.checkLimited(this)
	}

	bChanged = () => {
		return Tyan.utility.hasChangedValues(this)
	}

	handlerChange = (v) => {
		Tyan.doPostEvent('GetRelationInfo', {
			data: { type: '设备编号', objRelationInfo: { '设备': v } },
			onEnd: ({ errorMessage, optionsParas, objInfo }) => {
				if (optionsParas) {
					this.setState({ optionsParas: { ...this.state.optionsParas, ...optionsParas } })
				}
				if (objInfo) {
					Tyan.utility.changeItemsValue(this, '基本信息',
						['设备编号', '设备名称', '设备型号', '设备厂家', '试验类型'],
						[objInfo.InstrumentNumber, objInfo.InstrumentName, objInfo.F1, objInfo.F0, objInfo.F6])
				}
			}
		})
	}

	fieldset基本信息 = () => {
		const { readOnly } = this.state
		const statusName = Tyan.utility.getFormValue(this, '基本信息', '状态')
		const bUpload = statusName == '记录上传'
		return [
			{
				_border: '基本信息', minWidth: '100%', forceDisabled: true,
				items: [
					{ _text: '申请单号', },
					{ _text: '申请人', },
					{ _text: '申请部门', },
					{ _date: '申请日期', },
				]
			},
			{
				_border: '设备信息', minWidth: '100%', forceDisabled: readOnly || !['申请中'].includes(statusName),
				items: [
					{ _select: '设备编号', required: true, editable: true, forceSelection: false, onChange: (v) => this.handlerChange(v) },
					{ _text: '设备名称', disabled: true, },
					{ _text: '设备型号', disabled: true, },
					{ _text: '设备厂家', disabled: true, },
					{ _text: '试验类型', disabled: true, },
					{ _date: '故障时间', required: true, },
					{ _text: '维修部位', required: true, },
					{ _text: '故障现象', required: true, minWidth: '100%', maxRows: 3 },
					{ _text: '备注', name: '故障备注', minWidth: '100%', maxRows: 3 },
					{ _files: '附件', minWidth: '100%', },
				]
			},
			{
				_border: '维修记录', minWidth: '100%', forceDisabled: readOnly || !bUpload,
				items: [
					{ _date: '维修日期', required: bUpload, },
					{ _text: '维修人', required: bUpload, },
					{ _text: '备注', name: '维修备注', minWidth: '100%', maxRows: 3 },
					{ _files: '维修记录表', minWidth: '100%', },
				], cdt: () => ['记录上传', '已完成'].includes(statusName),
			},
		]
	}

	render() {
		const { showMessage: Message, showBody: Body } = this.props
		const { id, readOnly, initValues基本信息, } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		const bChanged = this.bChanged()
		const { 状态: statusName } = initValues基本信息
		return <Body data={this} maxWidth={1000}
			controls={
				readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
					[
						{ _flow: 'InstrumentRepairFlow', disabled: bChanged, cdt: () => id > 0 },
						{ _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
						{ _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 && statusName == '申请中' },
						{ _button: bChanged && '取消' || '关闭', handler: this.handlerClose },
					]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
				]}
		/>
	}
}

export default InstrumentRepairDetail